// 学期api
import {baseRequest} from './base'

/**
 * @desc 查询学期列表
 */
function getTermList(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaTerm/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 根据学期ID获取学期信息
 */
function getTermById(id){
  return baseRequest(`/api/pcWeb/teaTerm/${id}`,'get');
}

/**
 * @desc 新增学期
 */
function addTerm(params){
  return baseRequest(`/api/pcWeb/teaTerm/create`,'post',params);
}

/**
 * @desc 删除学期
 */
function deleteTerm(id){
  return baseRequest(`/api/pcWeb/teaTerm/delete/${id}`,'get');
}

/**
 * @desc 修改学期
 */
function updateTerm(id,params){
  return baseRequest(`/api/pcWeb/teaTerm/update/${id}`,'post',params);
}

/**
 * @desc 查询学期列表_不分页所有的
 */
function getTermList_all(params){
  //清除空白字段
  return baseRequest('/api/pcWeb/teaTerm/list','get');
}



export default {
  getTermList: getTermList,
  getTermById: getTermById,
  addTerm: addTerm,
  deleteTerm: deleteTerm,
  updateTerm: updateTerm,
  getTermList_all: getTermList_all,
}